<template>
  <router-link tag="div" :to="link" id="button-large-light" class="text-center w-100">
    <h4 class="font-weight-bold mb-0 md-headline pt-3 text-primary">{{ titulo }}</h4>
    <h6 class="pb-3 md-subheading mt-0">{{ subTitulo }}</h6>
  </router-link>
</template>

<script>
  export default {
    name: 'ButtonLargeLight',
    props: {
      titulo: { type: String, default: "Titulo" },
      subTitulo: { type: String, default: "Sub Titulo" },
      link: { type: String, default: "/" }
    }
  }
</script>

<style scoped lang="scss">
  #button-large-light {
    cursor: pointer;
    transition: 250ms;
  &:hover {
     border-radius: 5px;
     background-color: #e2e2e2;
   }
  }
</style>
